export default __webpack_public_path__ + "static/media/Helena 9781846168888.f6185d4f.jpg";